import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { queryUserTreeList } from '@/api/api';
import Vue from 'vue';
import pick from 'lodash.pick';
import { httpAction } from '@/api/manage';
export default {
  name: 'FaceModal',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: 'AI人脸表单',
      tableName: 'ai_face',
      form_fields: ['faceId', 'name', 'sex', 'type', 'userId', 'srcId', 'tenantId'],
      form_fields_time: [],
      validatorRules: {},
      userTree: [],
      //人员信息
      headers: {},
      picUrl: '',
      uploadLoading: false,
      disableSubmitPhoto: false,
      tenant: '',
      url: {
        fileUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['imgDomainURL']
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    var token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      'X-Access-Token': token
    };
    this.loadTreeList();
    this.tenant = window.localStorage.getItem('tenant');
  },
  computed: {
    uploadAction: function uploadAction() {
      return this.url.fileUpload;
    }
  },
  methods: {
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    beforeUpload: function beforeUpload(file) {
      var fileType = file.type;

      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      } //TODO 验证文件大小

    },
    handleChange: function handleChange(info) {
      this.picUrl = '';

      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }

      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoading = false;

        if (response.success) {
          this.model.srcId = response.result.id;
          this.picUrl = 'Has no pic url yet';
        } else {
          this.$notification.warning({
            message: response.message
          });
        }
      }
    },
    getAvatarView: function getAvatarView() {
      console.log(this.model.srcId);
      return this.url.imgerver + '/' + this.model.srcId;
    },
    add: function add() {
      this.picUrl = '';
      this.edit({});
    },
    edit: function edit(record) {
      var _this2 = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.disableSubmitPhoto = false;

      if (this.model.id != undefined) {
        if (this.model.faceId.indexOf('service_') == -1) {
          this.disableSubmitPhoto = true;
        }

        this.picUrl = 'Has no pic url yet';
      }

      this.$nextTick(function () {
        var that = _this2;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form.setFieldsValue(timeVal);
      });
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          var httpurl = '',
              method = '';

          if (!_this3.model.id) {
            httpurl = _this3.url.add ? _this3.url.add : _this3.pagePath;
            method = 'post';
            formData.tenantId = _this3.tenant;
            formData.faceId = _this3.guid();
          } else {
            httpurl = _this3.url.edit ? _this3.url.edit : _this3.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    guid: function guid() {
      return 'xxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }
};